class DirectChat {

    constructor(CegoXMPP) {
        this.CegoXMPP = CegoXMPP;
        this.UNREAD_MESSAGES = {};

        /* Select elements */
        this.directChatDock = jQuery(".directChatDock", this.CegoXMPP.chatContainer);
        this.directChatIcon = jQuery(".iconDirectChat", this.CegoXMPP.chatContainer);
        this.notificationSlider = jQuery(".chatNotifications", this.CegoXMPP.chatContainer);
        this.AUTO_HIDE_TIMER = {};
        this.AUTO_HIDE_DELAY = 3500;
        this.makeChatPersistent = false;
    }

    init() {
        this.notificationSlider.on('click', function () {
            this.hideNotificationSlider();
        }.bind(this)).on('mouseenter', function () {
            clearTimeout(this.AUTO_HIDE_TIMER);
        }.bind(this)).on('mouseleave', function () {
            this.autoHideNotificationSlider();
        }.bind(this));
        this.loadSavedChatItems();
        this.maintainTimeAgo();
        setInterval(() => {
            this.maintainTimeAgo();
        }, 60000);
    }

    handleChat(user, text, timestamp) {
        if (this.getChat(user.u).length === 0) {
            this.loadChat(user.u);
            this.createDockedChat(user, text, timestamp);
            this.notify(user, text);
            this.addUnreadMessageCount(user.u);
            this.updateTotalUnreadMessages();
            this.updateUnreadMessages(user.u);
            app.sounds.dingdong();
        } else if (!this.CegoXMPP.isCurrentPane("[data-name='" + user.u + "']")) {
            this.notify(user, text);
            this.addUnreadMessageCount(user.u);
            this.updateTotalUnreadMessages();
            this.updateUnreadMessages(user.u);
            app.sounds.ding();
        } else {
            this.CegoXMPP.sendEventToAllClients({'event': 'unread', 'username': user.u});
        }
    }

    beginDirectChat(username) {
        this.makeChatPersistent = true;
        this.CegoXMPP.Users.getUserObject(username, function (user) {
            this.initiateDirectChat(user);
        }.bind(this));
    }

    initiateDirectChat(user, message) {
        if (this.CegoXMPP.Users.isBlocked(user.u)) {
            return;
        }
        if (user.d === false && !this.CegoXMPP.Users.isAdminUser(app.config.user.u)) {
            return;
        }
        let directChat = this.getChat(user.u);
        message = (message === undefined) ? "..." : message;
        if (directChat.length > 0) {
            this.showChat(user.u);
        } else {
            this.createDockedChat(user, message);
            this.showChat(user.u);
            this.showAttention(user.u);
        }
    }

    showDirectChatList() {
        this.CegoXMPP.showPane('directChatDock');
        this.maintainTimeAgo();
        this.arrangeChats();
    }

    toggleEmptyMessage() {
        if (jQuery('li', this.directChatDock).length > 0) {
            jQuery('.emptyMessage', this.directChatDock).hide();
        } else {
            jQuery('.emptyMessage', this.directChatDock).show();
        }
    }

    arrangeChats() {
        let ul = jQuery('ul', this.directChatDock);
        ul.children('li').detach().sort(this.sortByTimestamp).appendTo(ul);
    }

    sortByTimestamp(a, b) {
        const aTime = jQuery(a).attr('data-timestamp');
        const bTime = jQuery(b).attr('data-timestamp');
        if (aTime) {
            a = parseInt(aTime.substr(0, 10), 10);
        } else {
            a = 0;
        }
        if (bTime) {
            b = parseInt(bTime.substr(0, 10), 10);
        } else {
            b = 0;
        }
        return a < b ? 1 : -1;
    }

    updateTextInDockedChat(username, text, timestamp = null, isMe = false) {
        let chatDocked = this.getDockedChat(username);
        text = this.CegoXMPP.Emoticons.replaceIcons(this.CegoXMPP.WordFilter.filterBadWords(text));

        if (isMe) {
            jQuery('.text', chatDocked).html(text).addClass("isMe");
        } else {
            jQuery('.text', chatDocked).html(text).removeClass("isMe");
        }
        timestamp ? this.CegoXMPP.Time.getTimestamp() : timestamp;
        timestamp = parseInt(timestamp.toString().substr(0, 10), 10);
        jQuery('.time', chatDocked).attr('data-time', timestamp);
        chatDocked.attr("data-timestamp", timestamp);
        this.arrangeChats();
        this.maintainTimeAgo();
    }

    createDockedChat(user, text, timestamp) {
        if (!this.CegoXMPP.config.user.d && !this.CegoXMPP.Users.isAdminUser(user.u)) {
            return;
        }
        let chatItem = this.getDockedChat(user.u);
        if (chatItem.length === 0) {
            timestamp = (timestamp === undefined) ? this.CegoXMPP.Time.getTimestamp() : timestamp;
            timestamp = parseInt(timestamp.toString().substr(0, 10), 10);
            chatItem = jQuery('.directChatItem', this.CegoXMPP.chatTemplates).clone();
            chatItem.attr('data-username', user.u);
            chatItem.attr('data-delete', user.u);
            chatItem.attr('data-timestamp', timestamp);
            jQuery('.username', chatItem).addClass(user.k).text(user.u).on("click", () => {
                this.CegoXMPP.showUserMenu(user.u);
            });
            jQuery('.profileImage', chatItem).css('background-image', 'url("' + this.CegoXMPP.Users.getProfileImage(user) + '")');
            jQuery('.text', chatItem).html(this.CegoXMPP.Emoticons.replaceIcons(this.CegoXMPP.WordFilter.filterBadWords(text)));
            $(".text,.profileImage,.time", chatItem).on("click", () => {
                this.showChat(user.u);
            });
            jQuery('.time', chatItem).attr('data-time', timestamp);
            jQuery('.directChatList', this.directChatDock).prepend(chatItem);
        }

        this.arrangeChats();
        this.maintainTimeAgo();
        this.toggleEmptyMessage();
    }

    getDockedChat(username) {
        return jQuery('.directChatItem[data-username="' + username + '"]', this.directChatDock);
    }

    maintainTimeAgo() {
        const that = this;
        let timeAgoItems = jQuery('.directChatItem .time', this.CegoXMPP.chatContainer);
        timeAgoItems.each(function () {
            jQuery(this).text(that.CegoXMPP.Time.timeAgo(that.CegoXMPP.language, jQuery(this).attr('data-time')));
        });
    }

    showChat(username) {
        this.CegoXMPP.sendUserPresence(username);
        this.loadChat(username);
        this.CegoXMPP.showPane('directChat[data-name="' + username + '"]', username);
        this.CegoXMPP.sendEventToAllClients({'event': 'unread', 'username': username});
        this.makeChatPersistent = true;
    }

    showAttention(username) {
        let att = jQuery('.writeMessageAttention', this.CegoXMPP.chatContainer);
        att.text(this.CegoXMPP.language.startConversationWith.replace('XX', username));
        att.css('bottom', "100%");
        att.fadeIn(this.CegoXMPP.ANIMATION_SPEED).animate({
            'bottom': '70px'
        }, 500, function () {
            setTimeout(function () {
                att.hide(500);
            }.bind(this), 3000);
        }.bind(this));
    }

    createChat(username) {
        if (username) {
            let chat = jQuery(".CCcontainer .pane[data-name='" + username + "']");
            if (chat.length === 0) {
                chat = jQuery('.CCtemplate .directChat').clone();
                chat.attr('data-name', username);
                jQuery("#panes").append(chat);
            }
        }
    }

    getChat(username) {
        return jQuery('.directChat[data-name="' + username + '"]', this.CegoXMPP.chatContainer);
    }

    removeChat(username) {
        this.getDockedChat(username).remove();
        this.getChat(username).remove();
        this.resetUnreadMessages(username);
        this.toggleEmptyMessage();
        delete app.config.direct_chats[username];
    }

    addUnreadMessageCount(username) {
        if (this.UNREAD_MESSAGES[username] > 0) {
            this.UNREAD_MESSAGES[username]++;
        } else {
            this.UNREAD_MESSAGES[username] = 1;
        }
        this.setLocalStorage("unread:" + username, this.UNREAD_MESSAGES[username]);
    }

    resetUnreadMessages(username) {
        this.UNREAD_MESSAGES[username] = 0;
        this.removeLocalStorage("unread:" + username);
        let dockedChat = this.getDockedChat(username);
        let numContainer = jQuery('.number', dockedChat);
        numContainer.text('');
        numContainer.hide();
        this.updateTotalUnreadMessages();
    }

    updateUnreadMessages(username) {
        const count = this.UNREAD_MESSAGES[username];
        let numContainer = jQuery('.number', this.getDockedChat(username));
        if (count) {
            numContainer.text(count).fadeIn(this.CegoXMPP.ANIMATION_SPEED);
        } else {
            numContainer.text("").fadeOut(this.CegoXMPP.ANIMATION_SPEED);
        }
    }

    updateTotalUnreadMessages() {
        let numTotal = 0;
        for (let prop in this.UNREAD_MESSAGES) {
            if (this.UNREAD_MESSAGES[prop]) {
                numTotal += this.UNREAD_MESSAGES[prop];
            }
        }
        if (numTotal > 0) {
            let numContainer = jQuery('.number', this.directChatIcon);
            numContainer.text(numTotal).show();
            const notify = jQuery("#instantMessages notify");
            if (notify.length) {
                notify.text(numTotal).addClass("active");
            }
        } else {
            this.resetTotalUnreadMessages();
        }
    }

    resetTotalUnreadMessages() {
        let numContainer = jQuery('.number', this.directChatIcon);
        numContainer.text('');
        numContainer.hide();

        if (this.CegoXMPP.CHAT_STATE === this.CegoXMPP.CHAT_STATES.chat) {
            document.querySelector('#instantMessages notify').innerHTML = '';
            document.querySelector('#instantMessages notify').classList.remove('active');
        }
    }

    loadSavedChatItems() {
        if (app.config.direct_chats) {
            for (let username in app.config.direct_chats) {
                if (this.getDockedChat(username).length === 0) {
                    this.CegoXMPP.Users.getUserObject(username, (user) => {
                        if (app.config.direct_chats[username].messages.length) {
                            const lastMessage = app.config.direct_chats[username].messages[app.config.direct_chats[username].messages.length - 1];
                            this.createDockedChat(user, lastMessage.txt, lastMessage.timestamp);
                            this.updateTextInDockedChat(user.u, lastMessage.txt, lastMessage.timestamp, this.CegoXMPP.Users.isMe(lastMessage.username));
                        }
                    });
                    this.UNREAD_MESSAGES[username] = this.getLocalStorage("unread:" + username);
                    if (this.UNREAD_MESSAGES[username]) {
                        this.UNREAD_MESSAGES[username] = parseInt(this.UNREAD_MESSAGES[username], 10);
                    } else {
                        this.UNREAD_MESSAGES[username] = 0;
                    }
                    this.updateUnreadMessages(username);
                }
            }
            this.updateTotalUnreadMessages();
            this.arrangeChats();
        }
        this.CegoXMPP.loading('hide');
    }

    setLocalStorage(name, value) {
        app.storage.set(app.config.user.id + ":" + name, value);
    }

    getLocalStorage(name) {
        return app.storage.get(app.config.user.id + ":" + name);
    }

    removeLocalStorage(name) {
        app.storage.remove(app.config.user.id + ":" + name);
    }

    loadChat(username) {
        if (username) {
            if (this.isLoaded(username) === false) {
                this.createChat(username);
            }
            this.CegoXMPP.Users.getUserObject(username, (user) => {
                app.ajax.get("/services/chat/get/" + username, {}, (data) => {
                    for (let i in data) {
                        this.CegoXMPP.insertDirectChatLine(username, this.CegoXMPP.Users.isMe(data[i].username) ? app.config.user : user, data[i].txt, data[i].timestamp);
                    }
                    this.CegoXMPP.scrollToBottom(true);
                });
            });
        }
    }

    isLoaded(username) {
        return this.getChat(username).length > 0;
    }

    notify(user, text) {
        let notificationItem = jQuery('.notificationItem', this.CegoXMPP.chatTemplates).clone();
        notificationItem.addClass('chat');
        notificationItem.attr('data-nid', user.u);
        notificationItem.attr('data-username', user.u);
        jQuery('.title', notificationItem).text(user.u);
        jQuery('.notificationImage', notificationItem).css('background-image', 'url("' + this.CegoXMPP.Users.getProfileImage(user) + '")');
        jQuery('.text', notificationItem).html(this.CegoXMPP.Emoticons.replaceIcons(text));

        notificationItem.on('click', function () {
            this.removeFromSlider(notificationItem);
            this.showChat(user.u);
        }.bind(this));

        let existingItem = jQuery('.notificationItem[data-nid=' + user.u + ']', this.notificationSlider);
        if (existingItem.length > 0) {
            existingItem.replaceWith(notificationItem);
        } else {
            jQuery('.notificationList', this.notificationSlider).append(notificationItem);
        }
        this.showNotificationSlider();
    }

    removeFromSlider(item) {
        item.remove();

        var items = jQuery('ul li', this.notificationSlider).length;
        if (items === 0) {
            this.notificationSlider.hide();
        }
    }

    emptySlider() {
        jQuery('ul li', this.notificationSlider).remove();
    }

    showNotificationSlider() {
        this.notificationSlider.slideDown(150);
        this.autoHideNotificationSlider();
    }

    hideNotificationSlider() {
        clearTimeout(this.AUTO_HIDE_TIMER);
        this.notificationSlider.slideUp(50);
        this.emptySlider();
    }

    autoHideNotificationSlider() {
        clearTimeout(this.AUTO_HIDE_TIMER);
        this.AUTO_HIDE_TIMER = setTimeout(function () {
            this.hideNotificationSlider();
        }.bind(this), this.AUTO_HIDE_DELAY);
    }
}